import React, { useEffect, useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import { useConfig } from '../../../DataStore/ConfigContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';

const AlertDeleteStream = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify, closeSettings} = useTheme();

    const { deleteStream, setDeleteStream, getClasses } = useConfig();

    const handleClose = () => setDeleteStream({ show: false, stream: null });


   if (!deleteStream.stream) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxConfig.deleteStream(deleteStream.stream.stream_id);
        setLoading(false);
        if(server_response.status === "OK"){
            getClasses(true); // Refresh the classes list
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        closeSettings();
        handleClose();
    }

    return (
        <BsModal
            show={deleteStream.show}
            onClose={handleClose}
            title="Delete Class Stream"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm Delete
                    </button>
                    </>}
                </>
            }
        >


            {deleteStream.stream && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Please confirm that you want to delete this class stream, <i>{deleteStream.stream.stream_name}</i>.</h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b>The stream will be removed from any students who are currently enrolled in it.
                </p>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertDeleteStream;
